"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaContainerDesignSchema = exports.BackgroundMediaSchema = exports.overlayBlending = void 0;
var yup = __importStar(require("yup"));
var schemaUtils_1 = require("../schemaUtils");
var Image_schema_1 = require("../image/Image.schema");
var Video_schema_1 = require("../video/Video.schema");
var Css_schema_1 = require("../css/Css.schema");
var mediaCommon_schema_1 = require("./mediaCommon.schema");
var scroll = __spreadArrays(['none', 'fixed', 'scroll', 'local', 'parallax']);
var blendMode = __spreadArrays([
    'normal',
    'multiply',
    'screen',
    'darken',
    'lighten',
    'overlay',
    'colorDodge',
    'colorBurn',
    'hardLight',
    'softLight',
    'difference',
    'exclusion',
    'hue',
    'saturation',
    'color',
    'luminosity',
]);
var BackgroundTransforms = yup.object({
    scale: yup.number().min(0),
    opacity: yup
        .number()
        .min(0)
        .max(1),
});
exports.overlayBlending = yup.object({
    color: yup.string(),
    opacity: yup
        .number()
        .min(0)
        .max(1),
    contrast: yup
        .number()
        .min(0)
        .max(2),
    saturate: yup
        .number()
        .min(0)
        .max(2),
    blendMode: yup
        .mixed()
        .oneOf(blendMode)
        .default(blendMode[0]),
});
exports.BackgroundMediaSchema = schemaUtils_1.createDataSchema('BackgroundMedia', yup.object(__assign(__assign(__assign({ mediaRef: schemaUtils_1.createDataRef({
        Image: Image_schema_1.ImageSchema,
        Video: Video_schema_1.VideoSchema,
    }).notRequired(), mediaTransforms: BackgroundTransforms.notRequired(), overlayTransforms: BackgroundTransforms.notRequired(), imageOverlay: schemaUtils_1.createDataRef({ ImageOverlay: Image_schema_1.ImageSchema }).notRequired() }, mediaCommon_schema_1.alignmentSchemaField), mediaCommon_schema_1.fittingSchemaField), { scrollType: yup
        .mixed()
        .oneOf(scroll)
        .default(scroll[0]), showOverlayForMediaType: yup
        .mixed()
        .oneOf(['all', 'WixVideo', 'Image'])
        .default('WixVideo'), color: yup.string(), colorOpacity: yup.number(), colorOverlay: yup.string(), colorOverlayOpacity: yup.number(), overlayBlending: exports.overlayBlending.notRequired(), filterEffect: mediaCommon_schema_1.filterEffectSchemaObject.notRequired() })));
exports.mediaContainerDesignSchema = schemaUtils_1.createDataSchema('MediaContainerDesignData', yup.object({
    charas: yup.string().nullable(),
    background: schemaUtils_1.createDataRef({
        BackgroundMedia: exports.BackgroundMediaSchema,
    }).nullable(),
    dataChangeBehaviors: yup
        .array()
        .of(yup.object({
        trigger: yup.string(),
        type: yup.string(),
        part: yup.string(),
        name: yup.string(),
        params: yup.object({
            duration: yup.number(),
        }),
    }))
        .nullable(),
    cssStyle: Css_schema_1.cssStyle.default(undefined),
    themeMappings: yup.object(),
}));
//# sourceMappingURL=Media.schema.js.map